import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { LayoutModule } from '../../Common/Layout/layout.module';
import { LocalizationModule } from '../../Core/Localization/localization.module';
import { CommonDialogsModule } from '../../Common/Dialogs/common-dialogs.module';
import { MiscModule } from '../../Common/Misc/misc.module';
import { CommonMonitorSharedModule } from '../../Common/MonitorShared/common-monitor-shared.module';
import { UsersModule } from '../../Core/Users/users.module';
import { CommonFormsModule } from '../../Common/Forms/forms.module';
import { JournodexModule } from '../../Common/Journodex/journodex.module';
import { ReportsRoutingService } from './services/reports-routing.service';
import { ReportsComponent } from './components/Reports/reports.component';
import { ReportsHypeService } from './services/reports-hype.service';
import { ReportsLeftSidebarService } from './services/reports-left-sidebar.service';

@NgModule({
    imports: [
        /* Angular */
        CommonModule,
        FormsModule,

        /* Common/Core */
        LayoutModule,
        LocalizationModule,
        CommonDialogsModule,
        CommonMonitorSharedModule,
        MiscModule,
        UsersModule,
        CommonFormsModule,
        JournodexModule,

    ],
    declarations: [
        ReportsComponent
    ],
    exports: [
        ReportsComponent
    ],
    providers: [
        ReportsRoutingService,
        ReportsHypeService,
        ReportsLeftSidebarService
    ]
})
export class ReportsCoreModule { }
